//文字コードはutf-8

/* フッターキャラクターをスクロールで登場させる
========================================================*/
export function initFooterMascots() {
    const el = document.getElementById('js-footerMascots');
    if (!el) return;

    if (!('IntersectionObserver' in window)) {
        el.classList.add('is-visible');
        return;
    }

    const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                el.classList.add('is-visible');
                io.disconnect();
            }
        });
    }, { threshold: 0.25 });

    io.observe(el);
}
